export default [
  {
    title: 'Ongi etorri',
    element: 'body',
    text: 'Ongi etorri Idoniara, zure irudiak trukatzeko plataformara. Tour honetan erabiltzen ikasten lagunduko dizugu.'
  },
  {
    title: 'Nire gunea',
    element: '.idonia-header .toolbar__title',
    text: '"Nire gunea" esparruan Idonian dituzun karpeta, dokumentu eta azterketa guztiak ikusi ahal izango dituzu.'
  },
  {
    title: ' "+" botoia',
    element: '.action-fab button',
    text: 'Erabili menu hau edukien karpeta bat sortzeko, fitxategi bat edo zure gailuaren karpetak igotzeko.',
    clickNext: 'nav button',
    wait: 150,
    placement: {
      relativeTo: 'viewport',
      position: 'top'
    }
  },
  {
    title: 'Fitxategi partekatuak',
    element: 'a[data-name="shared"]',
    text: '"Nirekin partekatuta" atalean, beste erabiltzaile batzuek partekatutako fitxategiak eta karpetak ikusi ahal izango dituzu.',
    clickBack: 'nav button',
    wait: 150
  }
]



// WEBPACK FOOTER //
// ./src/components/common/tour/tours/mobile/eu-ES/regular.js